enum ActivityTypes {
  Development = "DEVELOPMENT",
  UnitTests = "UNIT_TESTS",
  SystemTests = "SYSTEM_TESTS",
  IntegratedTests = "INTEGRATED_TESTS",
  Management = "MANAGEMENT",
  ProductionMonitoring = "PRODUCTION_MONITORING",
  Deployment = "DEPLOYMENT",
  Eventual = "EVENTUAL",
}

export default ActivityTypes;
